"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = exports.MenuContext = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const client_1 = require("@apollo/client");
const react_spring_1 = require("react-spring");
const logo_1 = require("./logo");
const desktop_menu_elements_1 = require("./desktop-menu-elements");
const modal_menu_1 = require("./modal-menu");
const query_1 = require("./query");
exports.MenuContext = React.createContext({
    menuState: { modalVisible: false, searchVisible: false },
    setMenuState: null,
});
const client = (0, query_1.getClient)();
const Menu = (props) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const [menuState, setMenuState] = React.useState({
        modalVisible: false,
        searchVisible: false,
    });
    const fadeIn = (0, react_spring_1.useSpring)({
        position: 'fixed',
        transitionTimingFunction: 'ease-in-out',
        opacity: menuState.modalVisible ? 1 : 0,
        display: menuState.modalVisible ? 'block' : 'none',
    });
    const bgfadeIn = (0, react_spring_1.useSpring)({
        position: 'absolute',
        top: '0',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: -1,
        display: menuState.modalVisible || menuState.searchVisible ? 'block' : 'none',
        transitionTimingFunction: 'ease-in-out',
        opacity: menuState.modalVisible || menuState.searchVisible ? 1 : 0,
    });
    const { data, error, loading } = (0, client_1.useQuery)(query_1.getMenuElements, {
        fetchPolicy: 'network-only',
        client: props.client ? props.client : client,
    });
    if (error) {
        console.log(error);
    }
    if (loading) {
        return React.createElement("div", null);
    }
    const shouldShowLogo = () => {
        var _a;
        return (((_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a.logo) !== false ||
            menuState.modalVisible ||
            menuState.searchVisible);
    };
    let className = '';
    if (props.className) {
        className = `${props.className}`;
    }
    if (menuState.modalVisible || menuState.searchVisible) {
        className += ' menu-open';
    }
    if (!((_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a.transparent)) {
        className += ' menu-background';
    }
    else {
        className += ' menu-no-background';
    }
    return (React.createElement(exports.MenuContext.Provider, { value: { menuState, setMenuState } },
        React.createElement(MenuWrapper, { className: className, zIndex: menuState.modalVisible || menuState.searchVisible ? 200 : 100, transparent: ((_b = props === null || props === void 0 ? void 0 : props.config) === null || _b === void 0 ? void 0 : _b.transparent) || false },
            React.createElement(AnimatedDiv, { style: bgfadeIn },
                React.createElement(Bg, null)),
            shouldShowLogo() && React.createElement(logo_1.Logo, null),
            React.createElement(FlexEnd, null,
                React.createElement(desktop_menu_elements_1.DesktopMenuElements, { vistopp: ((_c = props.config) === null || _c === void 0 ? void 0 : _c.vistopp) === false ? false : true, menuelements: ((_d = props.config) === null || _d === void 0 ? void 0 : _d.nybygg)
                        ? (_e = data === null || data === void 0 ? void 0 : data.getMenu) === null || _e === void 0 ? void 0 : _e.nybyggmenu
                        : (_f = data === null || data === void 0 ? void 0 : data.getMenu) === null || _f === void 0 ? void 0 : _f.menu, history: props.history }))),
        React.createElement(ModalMenuAnimationHolder, { style: fadeIn },
            React.createElement(modal_menu_1.ModalMenu, { menuelements: (_g = data === null || data === void 0 ? void 0 : data.getMenu) === null || _g === void 0 ? void 0 : _g.submenu }))));
};
exports.Menu = Menu;
const FlexEnd = styled_components_1.default.div `
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
const AnimatedDiv = (0, styled_components_1.default)(react_spring_1.animated.div) ``;
const ModalMenuAnimationHolder = (0, styled_components_1.default)(react_spring_1.animated.div) `
  position: fixed;
  top: 56px;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 200;
  line-height: 1.3;

  @media (min-width: 1140px) {
    left: auto;
  }
`;
const MenuWrapper = styled_components_1.default.div `
  font-size: 18px;
  position: fixed;
  line-height: 1.3;
  left: 0;
  right: 0;
  top: 0;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  height: 66px;
  background-color: ${(props) => (props.transparent ? 'none' : '#171719')};
  z-index: ${(props) => (props.zIndex ? props.zIndex : 100)};
  padding: 0 30px;
`;
const Bg = styled_components_1.default.div `
  background-color: rgba(0, 0, 0, 0.9);
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  position: absolute;
  z-index: -1;
`;
//# sourceMappingURL=Menu.js.map